module.exports = __webpack_public_path__ + "static/media/model-banner.21fb6766.jpg";